import { connect } from 'react-redux'
import * as TackActions from '../stores/tack/actions';
import LoggedOutTackComponent from '../components/logged_out_tack';

const mapStateToProps = (state, ownProps) => {
  return {
    tack: state.default.tack,
    word: state.default.word,
    params: ownProps.match.params
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onReset: () => {
      dispatch(TackActions.reset())
    },
    onLoggedOutTack: (wordText, email, targetLanguage) => {
      dispatch(TackActions.loggedOutTack(wordText, email, targetLanguage))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOutTackComponent);



// WEBPACK FOOTER //
// ./src/containers/logged_out_tack.js